import { render, staticRenderFns } from "./RegrasPagamentoExibir.vue?vue&type=template&id=6c9d9526&"
import script from "./RegrasPagamentoExibir.vue?vue&type=script&lang=js&"
export * from "./RegrasPagamentoExibir.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports